import React from "react";
import { Box, Tooltip } from "@mui/material";
import EllipsisTooltipCell from "utils/ellipsisTooltipCell";
import {
  formatTargetModelsText,
  formatFrequencyText,
  formatTimeAMPM,
  getNextRebootTime,
} from "../helper";

export const WEEKDAYS = [
  { value: 1, label: "Mon" },
  { value: 2, label: "Tue" },
  { value: 3, label: "Wed" },
  { value: 4, label: "Thu" },
  { value: 5, label: "Fri" },
  { value: 6, label: "Sat" },
  { value: 0, label: "Sun" },
];

export const DEFAULT_RULE = {
  name: "",
  enable: true,
  modelNames: [],
  deviceIds: [],
  frequency: "Daily", // "Daily" or weekday numbers "1,3,5"
  time: "00:00",
};

export const getRebootTableColumns = ({
  columnHelper,
  styles,
  handleRowClick,
  devicesList = [],
}) => {
  return [
    columnHelper.accessor("name", {
      header: "Rule Name",
      enableSorting: true,
      cell: (info) => <EllipsisTooltipCell text={info.getValue()} />,
    }),
    columnHelper.accessor("modelNames", {
      header: "Target Model",
      enableSorting: true,
      size: 240,
      cell: (info) => {
        const rowData = info.row.original;
        const { text, hasMore, moreCount, tooltip } = formatTargetModelsText(
          rowData.modelNames,
          rowData.deviceIds,
          devicesList
        );

        if (hasMore) {
          return (
            <Tooltip title={tooltip} placement="bottom" arrow>
              <Box display="inline-flex" alignItems="center" sx={{ whiteSpace: "nowrap" }}>
                <span>{text}</span>
                <span className={styles["more-tag"]}>{`+${moreCount} more`}</span>
              </Box>
            </Tooltip>
          );
        }

        return (
          <Tooltip title={tooltip || ""} placement="bottom" disableHoverListener={!tooltip} arrow>
            <span>{text}</span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("frequency", {
      header: "Frequency",
      enableSorting: true,
      cell: (info) => formatFrequencyText(info.getValue()),
    }),
    columnHelper.accessor("time", {
      header: "Time",
      enableSorting: true,
      cell: (info) => formatTimeAMPM(info.getValue()),
    }),
    columnHelper.accessor("nextRun", {
      header: "Next Run",
      enableSorting: true,
      cell: (info) => {
        const rowData = info.row.original;
        return getNextRebootTime(rowData.frequency, rowData.time);
      },
    }),
    columnHelper.accessor("enable", {
      header: "Status",
      enableSorting: true,
      cell: (info) => (info.getValue() ? "Enabled" : "Disabled"),
    }),
  ];
};
